module.exports = __webpack_public_path__ + "static/appstore-c79b7fc2fc2c13633a9d6f2cf252b2d1.png";